module.exports = __webpack_public_path__ + "ClientApp/content/Finding-the-Meaning-in-Mourning1.png";